export default __webpack_public_path__ + "static/containers-dont-6b1398baae9b2bc1c01fa3827cc3fc4c.png";